<template>
  <div class="autofit-hero">
    <div class="hero-image"></div>
    <section class="cta-section">
      <h1>
        {{$t('text43')}}
      </h1>
      <p>
        {{$t('text44')}}
      </p>
      <div class="buttons">
        <button class="thq-button-filled" @click="gotoDemo">{{$t('text45')}}</button>
        <router-link to="#steps"><button class="thq-button-outline thq-button-animated">{{$t('text46')}}</button></router-link>
      </div>
    </section>
  </div>

  <div class="test06">
    <div class="test07">
      <div class="test08">
        <span class="test09">{{$t('text47')}}</span>
        <h2 class="test10">{{$t('text48')}}</h2>
        <p class="test11">{{$t('text49')}}</p>
        <div class="test12">
          <div class="test13">
            <h2 class="test14">{{$t('text50')}}</h2>
            <span class="test15">{{$t('text51')}}</span>
          </div>
          <div class="test16">
            <h2 class="test17">{{$t('text52')}}</h2>
            <span class="test18">{{$t('text53')}}</span>
          </div>
        </div>
        <div class="test12">
          <div class="test13">
            <h2 class="test14">{{$t('text54')}}</h2>
            <span class="test15">{{$t('text55')}}</span>
          </div>
          <div class="test16">
            <h2 class="test17">{{$t('text56')}}</h2>
            <span class="test18">{{$t('text57')}}</span>
          </div>
        </div>
      </div>
      <div class="test19">
        <img class="test20" alt="test20" src="../assets/vlecad_170628_lr_43_sv5_0739-1500w.jpg"/>
      </div>
    </div>
  </div>

  <section id="steps" class="steps-section">
    <div class="feature-step" v-for="(step, index) in steps" :key="index">
      <div class="step-number2">{{ index + 1 < 10 ? '0' + (index + 1) : index + 1 }}</div>
      <img  :src="step.image" :alt="step.title" class="step-image2" />
      <h3 class="step-title2 test03">{{ $t(step.title) }}</h3>
      <p class="step-description2 test04">{{ $t(step.description) }}</p>
    </div>
  </section>
  
  <!--
  <section id="steps" class="steps-section">
    <div class="step" v-for="(step, index) in steps" :key="index">
      <img :src="step.image" :alt="step.title" class="test02" />
      <div class="test05">{{ index + 1 < 10 ? '0' + (index + 1) : index + 1 }}</div>
      <h3 class="test03">{{ $t(step.title) }}</h3>
      <p class="test04">{{ $t(step.description) }}</p>
    </div>
  </section>
  -->

  <section class="discover-section">
    <div class="features-grid">
      <div v-for="(feature, index) in features" :key="index" :class="['feature-card', feature.highlight ? 'highlight' : '']">
        <h3>{{ $t(feature.title) }}</h3>
        <p>{{ $t(feature.description) }}</p>
      </div>
    </div>
  </section>

  <Footer/>

</template>

<script>
import Footer from "../components/Footer.vue";

export default {
  name: 'Features',
  components: { Footer },
  data() {
    return {
      steps: [
        {
          image: new URL('@/assets/vlecad_170628_lr_29_sv5_0582-1400w.jpg', import.meta.url).href,
          title: 'steps.step1.title',
          description: 'steps.step1.description',
        },
        {
          image: new URL('@/assets/vlecad_170628_lr_30_sv5_0585-1400w.jpg', import.meta.url).href,
          title: 'steps.step2.title',
          description: 'steps.step2.description',
        },
        {
          image: new URL('@/assets/vlecad_170628_lr_15_sv5_0395-1400w.jpg', import.meta.url).href,
          title: 'steps.step3.title',
          description: 'steps.step3.description',
        },
        {
          image: new URL('@/assets/vlecad_170628_lr_64_sv5_0947-1400w.jpg', import.meta.url).href,
          title: 'steps.step4.title',
          description: 'steps.step4.description',
        },
      ],
      features: [
        {
          title: 'features.feature1.title',
          description: 'features.feature1.description',
          highlight: false
        },
        {
          title: 'features.feature2.title',
          description: 'features.feature2.description',
          highlight: true
        },
        {
          title: 'features.feature3.title',
          description: 'features.feature3.description',
          highlight: false
        },
        {
          title: 'features.feature4.title',
          description: 'features.feature4.description',
          highlight: true
        },
        {
          title: 'features.feature5.title',
          description: 'features.feature5.description',
          highlight: false
        },
        {
          title: 'features.feature6.title',
          description: 'features.feature6.description',
          highlight: true
        }
      ]
    }
  },
  methods: {
    toggle(index) {
      console.log("toggle");
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    gotoDemo() {
      this.$router.push('/contact');
    }
  }
}
</script>
<style scoped>
.feature-step {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 300px; /* optioneel, voor consistentie */
  margin: 0 auto;
}

.step-number2 {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.step-image2 {
  width: 100px;
  height: auto;
  border-radius: 8px;
  margin-bottom: 16px;
}

.step-title2 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 12px;
}

.step-description2 {
  font-size: 0.95rem;
  color: #444;
  max-width: 250px;
}



.test01 {
  flex: 1;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: var(--dl-color-theme-neutral-light);
}

.test02 {
  width: var(--dl-layout-size-large);
  height: var(--dl-layout-size-large);
  object-fit: cover;
  aspect-ratio: 1 / 1;
  border-radius: var(--dl-layout-radius-imageradius);
}

.test03 {
  font-size: 35px;
  font-family: STIX Two Text;
  font-weight: 600;
  line-height: 1.5;
}

.test04 {
  font-size: 16px;
  font-family: Noto Sans;
  line-height: 1.5;
}

.test05 {
  margin-top: -150px;
  margin-left: 170px;
  font-size: 40px;
  position: absolute;
  font-style: normal;
  font-weight: 700;
  font-family: STIX Two Text;
  line-height: 1.5;
}

.test06 {
  background-color: #f4cdac;
  width: 100%;
  display: flex;
  padding: var(--dl-layout-space-fiveunits);
  position: relative;
  align-items: center;
  flex-direction: column;
}

.test07 {
  gap: var(--dl-layout-space-fourunits);
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 1400px;
}

.test08 {
  align-self: center;
  align-items: flex-start;
  gap: var(--dl-layout-space-twounits);
  display: flex;
  overflow: hidden;
  position: relative;
  align-items: center;
  flex-direction: column;
}

.test09 {
  font-size: 16px;
  font-family: Noto Sans;
  line-height: 1.5;
}

.test10 {
  font-size: 35px;
  font-family: STIX Two Text;
  font-weight: 600;
  line-height: 1.5;
}

.test11 {
  font-size: 18px;
  font-family: Noto Sans;
  line-height: 1.5;
}

.test12 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}

.test13 {
  flex: 0 0 auto;
  width: 50%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.test14 {
  font-size: 35px;
  font-family: STIX Two Text;
  font-weight: 600;
  line-height: 1.5;
}

.test15 {
  font-size: 16px;
  font-family: Noto Sans;
  line-height: 1.5;
}

.test16 {
  flex: 0 0 auto;
  width: 50%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.test17 {
  font-size: 35px;
  font-family: STIX Two Text;
  font-weight: 600;
  line-height: 1.5;
}

.test18 {
  font-size: 16px;
  font-family: Noto Sans;
  line-height: 1.5;
}

.test19 {
  max-width: 50%;
}

.test20 {
  width: 100%;
  object-fit: cover;
  aspect-ratio: 1 / 1;
  border-radius: var(--dl-layout-radius-imageradius);
}

.autofit-hero {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
  background-color: #fff;
}

.hero-image {
  width: 100%;
  height: 70vh;
  background: url('@/assets/vlecad_170628_lr_43_sv5_0739-1500w.jpg') no-repeat center center/cover;
}

.cta-section {
  padding: 40px 20px;
  text-align: center;
  background-color: #fff;
}

.cta-section h1 {
  font-size: 2rem;
  margin-bottom: 20px;
}

.cta-section p {
  font-size: 1rem;
  max-width: 600px;
  margin: 0 auto 30px;
  color: #666;
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 24px;
  font-size: 0.9rem;
  text-decoration: none;
  border-radius: 5px;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
}

.btn-primary {
  background-color: #e65c2b;
  color: white;
}

.btn-primary:hover {
  background-color: #c84f25;
}

.btn-secondary {
  border: 1px solid #e65c2b;
  color: #e65c2b;
  background-color: transparent;
}

.btn-secondary:hover {
  background-color: #fbe9e3;
}

.steps-section {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 60px 20px;
  background-color: #fdfdfd;
  gap: 40px;
  max-width: 1400px;
  margin: 0 auto;
  align-items: flex-start;

}

.step {
  max-width: 260px;
  flex: 1 1 220px;
}

.step-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 10px;
  margin-bottom: 10px;
}

.step-number {
  font-size: 1.2rem;
  font-weight: bold;
  color: #999;
  margin-bottom: 10px;
}

.step-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 10px;
}

.step-description {
  font-size: 0.9rem;
  color: #444;
}

.discover-section {
  background-color: #ffffff;
  padding: 40px 20px;
  text-align: center;
}

.intro-container {
  max-width: 600px;
  margin: 0 auto 40px auto;
}

.intro-container h2 {
  font-size: 2rem;
  margin-bottom: 10px;
}

.intro-container p {
  color: #555;
  margin-bottom: 20px;
}

.main-button {
  background-color: #d35400;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.main-button:hover {
  background-color: #b43f00;
}

.features-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

@media (min-width: 768px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .features-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.feature-card {
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 20px;
  text-align: left;
  transition: box-shadow 0.3s ease;
}

.feature-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.feature-card h3 {
  font-size: 1.1rem;
  margin-bottom: 10px;
}

.feature-card p {
  color: #444;
  line-height: 1.4;
}

.feature-card.highlight {
  background-color: #f6d6b0;
}
</style>
